export const mergeStylesForMail = (html: string) => {
  if (html.includes('class="email-text"')) {
    return html;
  }

  return `<div class="email-text"> <style> @import url('https://fonts.cdnfonts.com/css/din-2014'); .email-text * { font-family: 'DIN 2014', Arial, sans-serif !important; font-size: 14px; line-height: 20px; color: #1D252D; margin: 0; } a, a * { color: #AE955F !important; text-decoration-color: #AE955F !important; } .email-text div > p:not(:first-of-type) { padding-top: 20px; min-height: 20px; box-sizing: content-box; } </style> ${html} </div>`;
};
